import moment from 'moment/moment'
import IndexController from '../index_controller'
import escapeHtml from '../../utils/sanitize'
import '../../entrypoints/modules/semantic-ui-dropdown'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'

$.fn.api = require('semantic-ui-api')
$.fn.search = require('semantic-ui-search')

let pendingLinkFormId = null
let pendingLinkedIssueIds = []

export default class extends IndexController {
  connect () {
    super.connect()

    super.initializeFromToDateFilters()

    this.initialiseLinkToIssue()
  }

  // this can be avoided if I represent main section partial
  setUIFilterDefaults () {
    this.disableFilterEvents()
    $('#from-date-filter').datepicker('clearDates')
    $('#to-date-filter').datepicker('clearDates')
    this.enableFilterEvents()
  }

  buildFilters () {
    const filters = super.buildFilters()

    const fromDate = moment.utc(
      $('#from-date-filter').data('datepicker').getDate()
    )
    const toDate = moment
      .utc($('#to-date-filter').data('datepicker').getDate())
      .add(1, 'd')
      .subtract(1, 's')

    if (fromDate && fromDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].from_date =
        fromDate.unix()
    }

    if (toDate && toDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].to_date =
        toDate.unix()
    }

    return filters
  }

  initialiseLinkToIssue () {
    $('#link_form_issue_target').dropdown({
      fullTextSearch: 'exact',
      placeholder: 'Search for issues...',
      filterRemoteData: true,
      apiSettings: {
        cache: false,
        saveRemoteData: false,
        url: '/internal/api/records?record_type=ISSUE&include_notified=true&search_term={query}',
        onResponse: function (response) {
          const result = { results: [] }

          if (!response || !response.results) {
            return result
          }

          response.results.forEach((issue) => {
            if (pendingLinkedIssueIds.includes(issue.id)) {
              return
            }
            result.results.push({
              name: '<span class="item-info rtext-sm reference-number">' + escapeHtml(issue.reference_number) + '</span>' +
                    '<br>' +
                    '<span class="mt-1 item-text title">' + escapeHtml(issue.title) + '</span>',
              value: issue.id
            })
          })

          return result
        }
      }
    })

    $('body').on('click', '.link-form-to-issue-btn', (ev) => {
      ev.stopPropagation()
      pendingLinkFormId = $(ev.currentTarget).data('form-id')
      const linkedIds = $(ev.currentTarget).data('linked-issue-ids')
      pendingLinkedIssueIds = linkedIds ? String(linkedIds).split(',') : []
      $('#link_form_issue_target').dropdown('clear')
      $('#modal-link-form-to-issue').modal('show')
    })

    $('body').on('click', '#link-form-to-issue-confirm', () => {
      this.submitLinkFormToIssue()
    })
  }

  submitLinkFormToIssue () {
    const issueId = $('#link_form_issue_target').dropdown('get value')

    if (!issueId || !pendingLinkFormId) {
      return
    }

    $.ajax({
      url: '/form/' + pendingLinkFormId + '/link-issue',
      type: 'POST',
      data: { issue_id: issueId },
      success: () => {
        $('#modal-link-form-to-issue').modal('hide')
        this.fetchResults(this.buildFilters())
      },
      error: () => {
        $('#modal-link-form-to-issue').modal('hide')
      }
    })
  }
}
